export const profile = () => [
  {
    value: 'profile',
    icon: 'fa-user',
    route: {
      name: 'editProfile',
    },
  },
  {
    value: 'password',
    icon: 'fa-lock',
    route: {
      name: 'editPassword',
    },
  },
];

export const systemSettings = () => [
  {
    value: 'medicalCondition',
    icon: 'fa-heart',
    route: {
      name: 'medicalConditions',
    },
  },
  {
    value: 'scalpCondition',
    icon: 'fa-cut',
    route: {
      name: 'scalpConditions',
    },
  },
  {
    value: 'mediaTag',
    icon: 'fa-images',
    route: {
      name: 'mediaTags',
    },
  },
];

export const userNew = () => [
  {
    value: 'profile',
    icon: 'fa-user',
    route: {
      name: 'createUser',
    },
  },
];

export const staffNew = () => [
  {
    value: 'profile',
    icon: 'fa-user',
    route: {
      name: 'createStaff',
    },
  },
];

export const user = ({ role }) => [
  {
    value: 'media',
    icon: 'fa-images',
    route: {
      name: 'editUserMedia',
      key: 'id',
    },
  },
  {
    value: 'profile',
    icon: 'fa-user',
    permission: role === 'customer' ? null : ['superadmin'],
    route: {
      name: 'editUser',
      key: 'id',
    },
  },
  {
    value: 'password',
    icon: 'fa-lock',
    permission: ['superadmin'],
    route: {
      name: 'editUserPassword',
    },
  },
  {
    value: 'logs',
    icon: 'fas fa-history',
    permission: role === 'customer' ? null : ['superadmin'],
    route: {
      name: 'userLogs',
    },
  },
];
